import { MetadataAction, TrackableMetadata } from '../actions/core-actions';

export const getActivityId = (action: MetadataAction<TrackableMetadata>): string | undefined => action.meta?.activityId;
